import { SendResetPasswordLink } from "@/components/forms/send.reset.password.link";
import { CreateNewPassword } from "@/components/forms/create.new.password";
import { useSearchParams } from "react-router-dom";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";

  if (token) {
    return <CreateNewPassword token={token} />;
  } else {
    return <SendResetPasswordLink />;
  }
};

export default ResetPassword;
